export type LatLngVector = {
  lat: number;
  lng: number;
};

export function vectorLen(p1: LatLngVector) {
  return Math.sqrt(p1.lat * p1.lat + p1.lng * p1.lng);
}

export function transform(vec: LatLngVector, k: number): LatLngVector {
  return {
    lng: vec.lng * k,
    lat: vec.lat * k
  };
}

export function plus(point: LatLngVector, vec: LatLngVector): LatLngVector {
  return {
    lng: point.lng + vec.lng,
    lat: point.lat + vec.lat
  };
}

export function toVector(p1: LatLngVector, p2: LatLngVector): LatLngVector {
  return {
    lng: p2.lng - p1.lng,
    lat: p2.lat - p1.lat
  };
}

export function angle(vec1: LatLngVector, vec2: LatLngVector) {
  return (vec1.lat * vec2.lat + vec1.lng * vec2.lng) / (vectorLen(vec1) * vectorLen(vec2));
}

export function rotate(vec: LatLngVector, angleRad: number): LatLngVector {
  const cos = Math.cos(angleRad);
  const sin = Math.sin(angleRad);
  return {
    lng: vec.lng * cos - vec.lat * sin,
    lat: vec.lng * sin + vec.lat * cos
  };
}

export function orient(p1: LatLngVector, p2: LatLngVector, p3: LatLngVector) {
  return (
    0.5 *
    ((p1.lng - p2.lng) * (p1.lat + p2.lat) +
      (p2.lng - p3.lng) * (p2.lat + p3.lat) +
      (p3.lng - p1.lng) * (p3.lat + p1.lat))
  );
}
